import script from "./SharedDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SharedDialog.vue?vue&type=style&index=0&id=1c5d8d6a&lang=postcss"

const __exports__ = script;

export default __exports__